const holidays = {
  headerButtons: {
    create: 'Erstellen',
    delete: 'Löschen',
  },

  table: {
    headers: {
      start: 'Starten',
      end: 'Ende',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
  },

  create: {
    successToast: {
      body: 'Feiertag wurde erfolgreich hinzugefügt',
    },
    errorModal: {
      header: 'Fehler aufgetreten',
      body: 'Feiertag konnte nicht erstellt werden',
    },
  },
  delete: {
    successToast: {
      body: 'Feiertage wurden erfolgreich gelöscht',
    },
    errorToast: {
      body: 'Feiertag konnte nicht erstellt werden',
    },
  },
  edit: {
    errorToast: {
      body: 'Feiertag konnte nicht erstellt werden',
    },
    successToast: {
      body: 'Der Feiertag wurde erfolgreich aktualisiert',
    },
    errorModal: {
      header: 'Fehler aufgetreten',
      body: 'Feiertag konnte nicht aktualisiert werden',
    },
    successModal: {
      header: 'Erfolg',
      body: 'Feiertag aktualisiert!',
    },
  },

  forms: {
    header: {
      create: {
        title: 'Erstellen',
      },

      update: {
        title: 'Aktualisieren',
      },
    },

    details: {
      header: 'Details',
      fields: {
        name: 'Name',
      },
    },
    dates: {
      header: 'Datumsbereich',
      fields: {
        rangeSwitch: 'Datumsbereich',
        start: 'Starten',
        end: 'Ende',
        date: 'Datum',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },
  },
};

export default holidays;
